<template>
  <div class="SettingsSectionDetails">
    <SettingsSectionTitle>{{ title }}</SettingsSectionTitle>
    <SettingsSectionDescription>
      {{ description }}
    </SettingsSectionDescription>
  </div>
</template>

<script>
import SettingsSectionTitle from "./SettingsSectionTitle.vue";
import SettingsSectionDescription from "./SettingsSectionDescription.vue";

export default {
  components: {
    SettingsSectionTitle,
    SettingsSectionDescription,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
  },
};
</script>

<style>
.SettingsSectionDetails {
  display: flex;
  flex-direction: column;
  max-width: 420px;
  margin-right: auto;
}
</style>
